import React, { useEffect } from "react";
import { useState } from "react";
import style from "../../../../../assets/styles/testCreationStyle.module.css";
import { Add_Section_Test, Get_Review } from "../../../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { GET_REVIEW_DATA } from "../../../../../action/apiPath";
import { CallWithAuth } from "../../../../../action/apiActions";
import QuillEditor from "../../../../atoms/QuillEditor";

// _________which one to show my or all _________

const SectionsDetails = () => {
  const dispatch = useDispatch();
  const { testDetails } = useSelector((state) => state.GetAllData);
  const [isLoading, setIsLoading] = useState(true); // State to track loading status

  // console.log("testDetails",testDetails)
  const groups = testDetails?.groups;
  const numOfGroups = groups?.flat();
  const groupDummy = numOfGroups;

  const [groupsbuttonIndex, setgroupsButtonIndex] = useState(0);

  const sections = testDetails?.groups.map((group) => group.sections);

  const temp = sections;

  const dummy = temp;


  // console.log("testDetails",testDetails)



  const { reviewdata } = useSelector((state) => state.GetAllData);
  useEffect(() => {
    setIsLoading(true);
    dispatch(Get_Review());
  }, [dispatch]);

  const [matchedQuestions, setMatchedQuestions] = useState([]);

  const [selectedSectionIndex, setSelectedSectionIndex] = useState(0);

  useEffect(() => {
    if (reviewdata) {
      setIsLoading(false);
    }
  }, [reviewdata]);

  useEffect(() => {
    const matched = temp[groupsbuttonIndex]
      ?.map((section) => {
        return section.questions
          .map((questionId) => {
            return reviewdata?.find(
              (question) => question.question_id === questionId
            );
          })
          .filter(Boolean);
      })
      ?.filter(Boolean);


    setMatchedQuestions(matched);
  }, [testDetails, reviewdata]);

  // console.log("reviewdata",reviewdata)

  // console.log("Matched questions ->", matchedQuestions);

  /*____________Filters out question bank according to section number */
  const uniqueQuestionIds = new Set();

  // const filteredQuestions = matchedQuestions[0].filter((question) => {
  //   const isInDummyQuestions = dummy[selectedSectionIndex].questions.includes(
  //     question.question_id
  //   );


  //   const isUnique = !uniqueQuestionIds.has(question.question_id);


  //   if (isInDummyQuestions && isUnique) {
  //     uniqueQuestionIds.add(question.question_id);
  //     return true;
  //   }
  //   return false;
  // });

  // console.log(" dekh =>>>>", filteredQuestions );

  // _________ALL question created listing data _________
  const [questionResults, setquestionResults] = useState([]);

  const QuestionListing = async () => {
    // console.log("dummy",dummy[groupsbuttonIndex][selectedSectionIndex])
    const url = GET_REVIEW_DATA + "?question_ids=" + dummy[groupsbuttonIndex][selectedSectionIndex].questions?.join(",");
    // console.log("checking API ->",url)
    // console.log("url", url);
    const questionlistingData = await CallWithAuth("GET", url);
    // console.log("questionlistingData", questionlistingData);
    if (questionlistingData.status && questionlistingData.res.status === 200) {
      setquestionResults(questionlistingData.res.data);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (dummy[groupsbuttonIndex][selectedSectionIndex].questions.length > 0) {
      QuestionListing();
    }
  }, [groupsbuttonIndex, selectedSectionIndex]);



  const extract = testDetails?.groups?.map((zen) => zen.randomize_sections);


  const decodeBase64 = (base64String) => {
    return atob(base64String);
  };



  function b64DecodeUnicode(str) {
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  }



  return (
    <div className={style.masterTestCreation}>
      <div className={style.testCreationArea}>
        <div style={{ display: "flex" }} className={style.containGroup}>
          {groupDummy?.map((items, index) => (
            <div style={{ width: "auto" }} className={style.bisect}>
              <button
                draggable="true"
                className={`${style.multiquestionbutton} ${groupsbuttonIndex === index
                  ? ` ${style.multiquestionbutton} ${style.draggable}`
                  : ` ${style.multiquestionbuttonBlue} ${style.draggable}`
                  }`}
                onClick={() => setgroupsButtonIndex(index)}
              >
                {items === groupsbuttonIndex ? (
                  <svg
                    width="10"
                    height="14"
                    viewBox="0 0 10 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg
                    width="10"
                    height="14"
                    viewBox="0 0 10 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                      fill="#272727"
                    />
                  </svg>
                )}{" "}
                &nbsp; Group {index + 1}
              </button>
            </div>
          ))}

          <div
            className={`${style.icon_text} ${style.group_icon}`}
          >
            <div style={{
              border: "1px solid #3ebb5d",
              height: "20px",
              width: "20px",
              borderRadius: "6px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
              {extract[groupsbuttonIndex] ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    fill="url(#paint0_linear_1449_53208)"
                  />
                  <path
                    d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1449_53208"
                      x1="22"
                      y1="2"
                      x2="7.89816"
                      y2="18.4928"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#9BF763" />
                      <stop offset="1" stop-color="#25AB5B" />
                    </linearGradient>
                  </defs>
                </svg>
              ) : (
                ""
              )}
            </div>

            <p className={style.info}>Randomize Sections Within Group</p>
          </div>
        </div>

        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className={style.threshold}
        >
        </div>

        {groupDummy[groupsbuttonIndex] && (
          <div className={style.section_form}>
            <h5 className={style.testMarklabel}>Group {groupsbuttonIndex + 1} Details</h5>
            <div className={style.groupName}>
              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                Group Name
                <b className={style.red_mendantory}>*</b>
              </span>

              <input
                type="textArea"
                placeholder="Group Name"
                className={style.groupDrop}
                disabled
                value={groupDummy[groupsbuttonIndex].name}
              />

              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                Group Instructions
              </span>
              {/* <Editor
                apiKey='43r1aznok44zxafnhlerjdhremu6cizk6ropi635y4we48qz'
                init={{
                  plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount linkchecker markdown',
                  toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                }}
                disabled
                initialValue={decodeBase64(groupDummy[groupsbuttonIndex].instructions)}
              /> */}


              <div style={{ height: "auto", flexGrow: "1" }}>
                <QuillEditor
                  defaultValue={decodeBase64(groupDummy[groupsbuttonIndex].instructions)}
                  disabled />
              </div>

              {/* <textarea
                type="textArea"
                placeholder="Type here"
                className={style.typeArea}
                disabled
                value={groupDummy[groupsbuttonIndex].instructions}
              /> */}

              {testDetails.rendering_template === 5 && <div className={`${style.icon_text} ${style.group_icon}`}>
                <div
                  style={{
                    border: "1px solid #3ebb5d",
                    height: "20px",
                    width: "20px",
                    borderRadius: "6px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {groupDummy[groupsbuttonIndex].has_unattempted_negative_marking ? (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                        fill="url(#paint0_linear_1449_53208)"
                      />
                      <path
                        d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_1449_53208"
                          x1="22"
                          y1="2"
                          x2="7.89816"
                          y2="18.4928"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#9BF763" />
                          <stop offset="1" stop-color="#25AB5B" />
                        </linearGradient>
                      </defs>
                    </svg>
                  ) : (
                    ""
                  )}
                </div>

                <p className={style.info}>Has Unattempted Negative Marking</p>
              </div>}


            </div>

            <h5 className={style.testMarklabel}>Sections</h5>
            <div className={style.containGroup}>
              {dummy[groupsbuttonIndex]?.map((section, index) => (
                <button
                  key={index}
                  draggable="true"
                  className={`${style.multiquestionbutton} ${selectedSectionIndex === index
                    ? ` ${style.multiquestionbutton} ${style.draggable}`
                    : ` ${style.multiquestionbuttonBlue} ${style.draggable}`
                    }`}
                  onClick={() => setSelectedSectionIndex(index)}
                >
                  {section === selectedSectionIndex ? (
                    <svg
                      width="10"
                      height="14"
                      viewBox="0 0 10 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                        fill="white"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="10"
                      height="14"
                      viewBox="0 0 10 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                        fill="#272727"
                      />
                    </svg>
                  )}{" "}
                  &nbsp; Section {index + 1}
                </button>
              ))}
            </div>
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className={style.threshold}
            >

            </div>
            {dummy[groupsbuttonIndex][selectedSectionIndex] && (
              <div
                style={{ marginTop: "1rem" }}
                className={style.pageTwoSection}
              >
                <div className={style.bound}>
                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Section Name </span>
                        <b className={style.red_mendantory}>*</b>
                        <input
                          name="question"
                          id="question"
                          className={` ${style.score_drop_filter} ${style.verbalBox}`}
                          placeholder="Verbal Ability & reading Comprehension"
                          disabled
                          value={dummy[groupsbuttonIndex][selectedSectionIndex].name}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Test type */}
                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Section Identifier </span>
                        <b className={style.red_mendantory}>*</b>
                        <select
                          name="question"
                          id="question"
                          className={` ${style.template_drop_filter} ${style.varc}`}
                          value={dummy[groupsbuttonIndex][selectedSectionIndex].identifier}
                          disabled
                        >
                          <option>
                            {dummy[groupsbuttonIndex][selectedSectionIndex].identifier}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>No. of Questions</span>
                        <b className={style.red_mendantory}>*</b>
                        <input
                          name="question"
                          id="question"
                          className={style.score_drop_filter}
                          placeholder="60"
                          value={dummy[groupsbuttonIndex][selectedSectionIndex].no_of_questions}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <p style={{ fontWeight: "500" }} className={style.marketLogic}>
                  Randomize Questions Within Section
                  <b className={style.red_mendantory}>*</b>{" "}
                </p>
                <div className={style.levels}>
                  {dummy[groupsbuttonIndex][selectedSectionIndex]
                    .randomize_questions_within_sections === true ? (
                    <>
                      <label htmlFor="test level">Yes</label>
                    </>
                  ) : (
                    ""
                  )}
                  {dummy[groupsbuttonIndex][selectedSectionIndex]
                    .randomize_questions_within_sections === false ? (
                    <>
                      <label htmlFor="section level">No</label>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <hr className={style.sectionsHR} />
                <h3 className={style.testMarklabel}>Group Marking Details</h3>
                <p className={style.info}>
                  Editing marking logic will only apply to selected section. All
                  questions will follow same marking logic unless new marking
                  logics are created
                </p>
                <div className={style.bound}>
                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Correct Answer Marks </span>
                        <b className={style.red_mendantory}>*</b>
                        <input
                          disabled
                          value={
                            dummy[groupsbuttonIndex][selectedSectionIndex].correct_answer_marks
                          }
                          name="question"
                          id="question"
                          className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Test type */}
                  <div className={style.templateDrop}>
                    <div className={style.templateDrop_item}>
                      <div className={style.templateGroup}>
                        <span>Incorrect Answer Marks </span>
                        <b className={style.red_mendantory}>*</b>
                        <input
                          disabled
                          value={
                            dummy[groupsbuttonIndex][selectedSectionIndex].incorrect_answer_marks
                          }
                          name="question"
                          id="question"
                          className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                        />
                      </div>
                    </div>
                  </div>
                </div>





                <hr className={style.sectionsHR} />
                <div className={style.questionBank}>
                  <div className={style.headerBank}>
                    <h4 style={{ fontWeight: "500" }}>Question List</h4>
                  </div>

                  <div
                    style={{ marginTop: "30px" }}
                    className={style.sub_head_content_table}
                  >
                    <div>
                      <table>
                        <thead>
                          <tr>
                            <th
                              className={` ${style.very_first} ${style.pointer}`}
                            >
                              S.No
                            </th>

                            <th
                              className={` ${style.very_first} ${style.pointer}`}
                            >
                              Question ID and Tags
                            </th>
                            <th className={` ${style.first} ${style.pointer}`}>
                              <span>General Tags</span>
                            </th>
                            <th className={` ${style.second} ${style.pointer}`}>
                              {" "}
                              <span>Author</span>
                            </th>
                            <th className={` ${style.third} ${style.pointer}`}>
                              <span>Created On</span>
                            </th>
                            <th className={` ${style.fourth} ${style.pointer}`}>
                              <span>LOD</span>
                            </th>

                            <th></th>
                          </tr>
                        </thead>

                        {/* {console.log("questionResults",questionResults,isLoading)} */}
                        {/* ALL AND MY QUESTION according to ternary operator */}
                        {isLoading ? (
                          <div className={style.mixed}>
                            <div className={style.spinner}></div>
                            <p className={style.loading_message}>Loading...</p>
                          </div>
                        ) : (
                          questionResults.map((data, index) => (
                            <tbody>
                              <tr className={style.table_body_content} key={index}>
                                <td className={style.srNo}>
                                  <div className={style.srContent}>
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.4375 4.6875C8.4375 4.93473 8.36419 5.1764 8.22684 5.38196C8.08949 5.58752 7.89426 5.74774 7.66585 5.84235C7.43745 5.93696 7.18611 5.96171 6.94364 5.91348C6.70116 5.86525 6.47843 5.7462 6.30362 5.57138C6.1288 5.39657 6.00975 5.17384 5.96152 4.93136C5.91329 4.68889 5.93804 4.43755 6.03265 4.20915C6.12726 3.98074 6.28748 3.78552 6.49304 3.64816C6.6986 3.51081 6.94027 3.4375 7.1875 3.4375C7.51902 3.4375 7.83696 3.5692 8.07138 3.80362C8.3058 4.03804 8.4375 4.35598 8.4375 4.6875ZM12.8125 5.9375C13.0597 5.9375 13.3014 5.86419 13.507 5.72684C13.7125 5.58949 13.8727 5.39426 13.9674 5.16585C14.062 4.93745 14.0867 4.68611 14.0385 4.44364C13.9903 4.20116 13.8712 3.97843 13.6964 3.80362C13.5216 3.6288 13.2988 3.50975 13.0564 3.46152C12.8139 3.41329 12.5626 3.43804 12.3341 3.53265C12.1057 3.62726 11.9105 3.78748 11.7732 3.99304C11.6358 4.1986 11.5625 4.44027 11.5625 4.6875C11.5625 5.01902 11.6942 5.33696 11.9286 5.57138C12.163 5.8058 12.481 5.9375 12.8125 5.9375ZM7.1875 8.75C6.94027 8.75 6.6986 8.82331 6.49304 8.96066C6.28748 9.09802 6.12726 9.29324 6.03265 9.52165C5.93804 9.75005 5.91329 10.0014 5.96152 10.2439C6.00975 10.4863 6.1288 10.7091 6.30362 10.8839C6.47843 11.0587 6.70116 11.1778 6.94364 11.226C7.18611 11.2742 7.43745 11.2495 7.66585 11.1549C7.89426 11.0602 8.08949 10.9 8.22684 10.6945C8.36419 10.4889 8.4375 10.2472 8.4375 10C8.4375 9.66848 8.3058 9.35054 8.07138 9.11612C7.83696 8.8817 7.51902 8.75 7.1875 8.75ZM12.8125 8.75C12.5653 8.75 12.3236 8.82331 12.118 8.96066C11.9125 9.09802 11.7523 9.29324 11.6577 9.52165C11.563 9.75005 11.5383 10.0014 11.5865 10.2439C11.6348 10.4863 11.7538 10.7091 11.9286 10.8839C12.1034 11.0587 12.3262 11.1778 12.5686 11.226C12.8111 11.2742 13.0624 11.2495 13.2909 11.1549C13.5193 11.0602 13.7145 10.9 13.8518 10.6945C13.9892 10.4889 14.0625 10.2472 14.0625 10C14.0625 9.66848 13.9308 9.35054 13.6964 9.11612C13.462 8.8817 13.144 8.75 12.8125 8.75ZM7.1875 14.0625C6.94027 14.0625 6.6986 14.1358 6.49304 14.2732C6.28748 14.4105 6.12726 14.6057 6.03265 14.8341C5.93804 15.0626 5.91329 15.3139 5.96152 15.5564C6.00975 15.7988 6.1288 16.0216 6.30362 16.1964C6.47843 16.3712 6.70116 16.4903 6.94364 16.5385C7.18611 16.5867 7.43745 16.562 7.66585 16.4674C7.89426 16.3727 8.08949 16.2125 8.22684 16.007C8.36419 15.8014 8.4375 15.5597 8.4375 15.3125C8.4375 14.981 8.3058 14.663 8.07138 14.4286C7.83696 14.1942 7.51902 14.0625 7.1875 14.0625ZM12.8125 14.0625C12.5653 14.0625 12.3236 14.1358 12.118 14.2732C11.9125 14.4105 11.7523 14.6057 11.6577 14.8341C11.563 15.0626 11.5383 15.3139 11.5865 15.5564C11.6348 15.7988 11.7538 16.0216 11.9286 16.1964C12.1034 16.3712 12.3262 16.4903 12.5686 16.5385C12.8111 16.5867 13.0624 16.562 13.2909 16.4674C13.5193 16.3727 13.7145 16.2125 13.8518 16.007C13.9892 15.8014 14.0625 15.5597 14.0625 15.3125C14.0625 14.981 13.9308 14.663 13.6964 14.4286C13.462 14.1942 13.144 14.0625 12.8125 14.0625Z"
                                        fill="#272727"
                                      />
                                    </svg>
                                    {index + 1}
                                  </div>
                                </td>
                                <td>
                                  <div className={style.question_id_tag}>
                                    <div className={style.id}>
                                      {data.question_id}
                                    </div>
                                    <div className={style.tag}>
                                      <p>{data.question_short_identifier}</p>
                                      <span>
                                        {data.primary_tag.subject} |{" "}
                                        {data.primary_tag.area} |{" "}
                                        {data.primary_tag.topic} |{" "}
                                        {data.primary_tag.subtopic}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {data?.free_tags?.map((tags) => (
                                    <div className={style.general_tag}>
                                      <button className={style.general_button}>
                                        {tags.name}
                                      </button>
                                    </div>
                                  ))}
                                </td>
                                <td>
                                  <div className={style.author_tag}>
                                    {data.created_by}
                                  </div>
                                </td>
                                <td>
                                  <div className={style.created_date}>
                                    {data.created_at}
                                  </div>
                                </td>
                                <td>
                                  <div className={style.lod}>
                                    {data.difficulty}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          ))
                        )}
                      </table>
                    </div>
                  </div>
                  <footer
                    style={{ display: "flex", gap: "0px" }}
                    className={style.sectionFooter}
                  >
                    {/* <div className={style.footer_content}>
                      <span style={{ fontWeight: "500" }}>
                        Selected Questions
                      </span>
                      <span>
                        0{" "}
                        <b style={{ color: "lightgray" }}>
                          /{dummy[selectedSectionIndex].questions.length}
                        </b>
                      </span>
                    </div> */}

                    {dummy[groupsbuttonIndex][selectedSectionIndex].questions?.map((item, i) => (
                      <div className={style.footer_content_mid} key={i}>
                        <span className={style.closeIds}>{item}</span>
                      </div>
                    ))}
                  </footer>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionsDetails;
